// src/utils/precios.js

/**
 * Calcula el precio de venta de un artículo usando la ganancia personalizada
 * si existe; si no, usa la ganancia global del usuario.
 *
 * Soporta la fórmula legacy del frontend: PRE_VTA * (1 + ganancia / 100).
 *
 * @param {Object} articulo - Debe contener al menos `PRE_VTA` y opcionalmente `ganancia_personalizada`.
 * @param {number} gananciaGlobal - Porcentaje de ganancia global del usuario.
 * @returns {number} Precio de venta calculado.
 */
export const calcularPrecioVenta = (articulo, gananciaGlobal) => {
  if (!articulo) return 0;

  const ganancia =
    articulo.ganancia_personalizada !== null && articulo.ganancia_personalizada !== undefined
      ? parseFloat(articulo.ganancia_personalizada)
      : parseFloat(gananciaGlobal || 0);

  const precioBase = parseFloat(articulo.PRE_VTA || 0);

  return precioBase * (1 + ganancia / 100);
};

/**
 * Devuelve el % de ganancia efectivo que se aplicó (personalizado o global).
 * Útil para mostrar en la UI.
 */
export const obtenerGananciaEfectiva = (articulo, gananciaGlobal) => {
  if (!articulo) return 0;
  return articulo.ganancia_personalizada !== null && articulo.ganancia_personalizada !== undefined
    ? parseFloat(articulo.ganancia_personalizada)
    : parseFloat(gananciaGlobal || 0);
};
